// import React, { useMemo, useState } from "react";
// import { Modal, Form } from "react-bootstrap";
// import { ReactIconsCombo } from "../../../../../utils/ReactIconsCombo";
// import "../styles/reactIconsModal.css";

// function ReactIconsModal({ show, onHide, onSelect }) {
//   const [search, setSearch] = useState("");

//   // Convert icons object → array
//   const iconsList = useMemo(() => {
//     return Object.entries(ReactIconsCombo).filter(([name]) =>
//       name.toLowerCase().includes(search.toLowerCase()),
//     );
//   }, [search]);

//   return (
//     <Modal show={show} onHide={onHide} size="xl" centered scrollable>
//       <Modal.Header closeButton>
//         <Modal.Title>Select Icon</Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         {/* Search */}
//         <Form.Control
//           placeholder="Search icon..."
//           className="mb-3"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />

//         {/* Icons Grid */}
//         <div className="icons-grid">
//           {Object.entries(ReactIconsCombo).map(([name, Icon]) => (
//             <div>
//               {/* RENDER ICON */}
//               <Icon size={24} />

//               {/* ICON NAME */}
//               <small>{name}</small>
//             </div>

//             // <div
//             //   key={name}
//             //   className="icon-item"
//             //   onClick={() => {
//             //     onSelect?.(name);
//             //     onHide();
//             //   }}
//             // >
//             //   <Icon size={26} />
//             //   <small>{name}</small>
//             // </div>
//           ))}
//         </div>

//         {iconsList.length === 0 && (
//           <div className="text-center text-muted py-4">No icons found</div>
//         )}
//       </Modal.Body>
//     </Modal>
//   );
// }

// export default ReactIconsModal;

import React, { createElement, useMemo, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { ReactIconsCombo } from "../../../../../utils/ReactIconsCombo";
import "../styles/reactIconsModal.css";

function ReactIconsModal({ show, onHide, onSelect }) {
  const [search, setSearch] = useState("");

  // Filter icons based on search
  const iconsList = useMemo(() => {
    return Object.entries(ReactIconsCombo).filter(([name]) =>
      name.toLowerCase().includes(search.toLowerCase()),
    );
  }, [search]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="custom-modal-width"
      centered
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Select Icon</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ overflowX: "hidden" }}>
        {/* Search Input */}
        <Form.Control
          placeholder="Search icon..."
          className="mb-3"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {/* Icons Grid */}
        <div className="icons-grid">
          {iconsList.map(([name, Icon]) => (
            <div className="selected-icon-preview mb-3 text-center">
              {createElement(ReactIconsCombo[name], { size: 40 })}
              <div className="mt-2" style={{ fontSize: "12px" }}>
                {name}
              </div>
            </div>
          ))}
        </div>

        {iconsList.length === 0 && (
          <div className="text-center text-muted py-4">No icons found</div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ReactIconsModal;
